<template>
  <span class="country-flag" :class="[`is-${size}`, { 'is-rounded': rounded }]">{{
    emoji
  }}</span>
</template>

<script>
// Drop-in replacement for vue-country-flag (no Vue3 version exists).
// Same "country" (2-letter ISO code) / "size" / "rounded" props so call sites are unchanged.
export default {
  name: "CountryFlag",
  props: {
    country: { type: String, required: true },
    size: { type: String, default: "normal" },
    rounded: { type: Boolean, default: false },
  },
  computed: {
    emoji() {
      const code = (this.country || "").toUpperCase();
      if (code.length !== 2) return "";
      const base = 0x1f1e6; // regional indicator symbol letter A
      return String.fromCodePoint(
        ...[...code].map((c) => base + (c.charCodeAt(0) - 65))
      );
    },
  },
};
</script>

<style scoped>
.country-flag {
  display: inline-block;
  line-height: 1;
}
.country-flag.is-small {
  font-size: 1rem;
}
.country-flag.is-normal {
  font-size: 1.5rem;
}
.country-flag.is-big {
  font-size: 2rem;
}
.country-flag.is-rounded {
  border-radius: 50%;
}
</style>
